import api from '../../config/axios.js';

const state = {
    openSessions: [],
    paymentHistory: [],
    parkingRate: null,
    parkingCameras: [],
    parkingLoading: false,
    parkingSettingsLoading: false,
    parkingError: "",
    parkingSuccess: ""
}

const getters = {
    getParkingOpenSessions: state => state.openSessions,
    getParkingPaymentHistory: state => state.paymentHistory,
    getParkingRate: state => state.parkingRate,
    getParkingCameras: state => state.parkingCameras,
    getParkingLoading: state => state.parkingLoading,
    getParkingSettingsLoading: state => state.parkingSettingsLoading,
    getParkingError: state => state.parkingError,
    getParkingSuccess: state => state.parkingSuccess
}

const actions = {
    async setParkingDashboard({ commit }) {
        commit("setParkingLoading", true);
        commit("setParkingError", "");

        await api.axios.get('/api/parking/dashboard').then(response => {
            if (response && response.status === 200) {
                commit("setParkingOpenSessions", response.data.open_sessions || []);
                commit("setParkingPaymentHistory", response.data.payment_history || []);
            }
        }).catch(() => {
            commit("setParkingError", "Erro ao buscar dados do estacionamento.");
        }).finally(() => {
            commit("setParkingLoading", false);
        });
    },
    async setParkingSettings({ commit }) {
        commit("setParkingSettingsLoading", true);
        commit("setParkingError", "");

        await api.axios.get('/api/parking/settings').then(response => {
            if (response && response.status === 200) {
                commit("setParkingRate", response.data.rate || null);
                commit("setParkingCameras", response.data.cameras || []);
            }
        }).catch(() => {
            commit("setParkingError", "Erro ao buscar configurações do estacionamento.");
        }).finally(() => {
            commit("setParkingSettingsLoading", false);
        });
    },
    async saveParkingSettings({ commit, dispatch }, data) {
        commit("setParkingSettingsLoading", true);
        commit("setParkingError", "");
        commit("setParkingSuccess", "");

        await api.axios.put('/api/parking/settings', data).then(response => {
            if (response && response.status === 200) {
                commit("setParkingSuccess", "Configuracoes salvas com sucesso.");
                dispatch("setParkingSettings");
            }
        }).catch(error => {
            const message = error && error.response && error.response.data
                ? error.response.data
                : "Erro ao salvar configurações do estacionamento.";
            commit("setParkingError", message);
        }).finally(() => {
            commit("setParkingSettingsLoading", false);
        });
    }
}

const mutations = {
    setParkingOpenSessions: function(state, data){
        state.openSessions = data;
    },
    setParkingPaymentHistory: function(state, data){
        state.paymentHistory = data;
    },
    setParkingRate: function(state, data){
        state.parkingRate = data;
    },
    setParkingCameras: function(state, data){
        state.parkingCameras = data;
    },
    setParkingLoading: function(state, data){
        state.parkingLoading = data;
    },
    setParkingSettingsLoading: function(state, data){
        state.parkingSettingsLoading = data;
    },
    setParkingError: function(state, data){
        state.parkingError = data;
    },
    setParkingSuccess: function(state, data){
        state.parkingSuccess = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
